/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_TitleInputs */

const en_pricing_title = /** @type {(inputs: Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simple, student-friendly pricing`)
};

const de_pricing_title = /** @type {(inputs: Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfache, studentenfreundliche Preise`)
};

const fr_pricing_title = /** @type {(inputs: Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarification simple et adaptée aux étudiants`)
};

const es_pricing_title = /** @type {(inputs: Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precios sencillos y amigables para estudiantes`)
};

const it_pricing_title = /** @type {(inputs: Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzi semplici e adatti agli studenti`)
};

const nl_pricing_title = /** @type {(inputs: Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eenvoudige, studentvriendelijke prijsstelling`)
};

const pl_pricing_title = /** @type {(inputs: Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proste, przyjazne dla studentów cenowanie`)
};

const fi_pricing_title = /** @type {(inputs: Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksinkertainen, opiskelijaystävällinen hinta`)
};

const da_pricing_title = /** @type {(inputs: Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enkel, studerendevenlig pris`)
};

const sv_pricing_title = /** @type {(inputs: Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enkel, studentvänlig prissättning`)
};

/**
* | output |
* | --- |
* | "Simple, student-friendly pricing" |
*
* @param {Pricing_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_title = /** @type {((inputs?: Pricing_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_title(inputs)
	if (locale === "fr") return fr_pricing_title(inputs)
	if (locale === "es") return es_pricing_title(inputs)
	if (locale === "it") return it_pricing_title(inputs)
	if (locale === "nl") return nl_pricing_title(inputs)
	if (locale === "pl") return pl_pricing_title(inputs)
	if (locale === "fi") return fi_pricing_title(inputs)
	if (locale === "da") return da_pricing_title(inputs)
	if (locale === "sv") return sv_pricing_title(inputs)
	return en_pricing_title(inputs)
});